module.exports = __webpack_public_path__ + "img/icon-fishing-black.f959ff65.svg";